import { render, staticRenderFns } from "./classStudent.vue?vue&type=template&id=dc2389b0&"
import script from "./classStudent.vue?vue&type=script&lang=js&"
export * from "./classStudent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports